import './loader.css'
const Loader=()=>{
    return (
        <div id="container" style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}} >
        <h1> 🔃😃Loading ...</h1>
        </div>
    )
}

export default Loader;